import React from "react";
import cs from "classnames";
import { useTranslation } from "react-i18next";
import { errors } from "../../lib/translation/strings";

import { Product } from "./Product";
import { ProductsLoader } from "./ListOfProductsLoader";
import { BulkLoader } from "../shared/BulkLoader/BulkLoader";
import { LoadMoreButton } from "../shared/LoadMoreButton/LoadMoreButton";
import { InfoMessage } from "../shared/InfoMessage/InfoMessage";
import { HandleLoadingState } from "../shared/HandleLoadingState/HandleLoadingState";
// import { ShopFilterActions } from "../Shop/ui/ShopFilterActions";

import { ProductProps } from "../../types/productTypes";

import "./ListOfProducts.scss";

interface Props {
  big?: boolean;
  className?: string;
  error?: string;
  loading?: boolean;
  products?: ProductProps[];
  isLoading: boolean;
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
  pageInfo: boolean;
  loadingPlaceholderNumber?: number;
  gridView?: "LIST" | "ONE";
  onLoadPrevious?: () => void;
  onLoadMore: () => void;
}

export const ListOfProducts = (props: Props) => {
  const { t } = useTranslation();
  const noProductsAvailable =
    !props.products || Number(props.products.length) === 0;

  return (
    <div className="ListOfProducts__wrapper">
      {props.hasPreviousPage && (
        <div className="mb-4">
          <LoadMoreButton
            btnLabel="Load previous"
            loading={props.loading || props.isLoading}
            onClick={() => {
              if (props.onLoadPrevious) {
                props.onLoadPrevious();
              }
            }}
          />
        </div>
      )}

      <div
        className={cs(
          "ListOfProducts",
          props.loading && "ListOfProducts__loading",
          props.gridView === "ONE" && "ListOfProducts__one",
          !props.loading &&
            noProductsAvailable &&
            !props.products?.length &&
            "ListOfProducts--empty",
          props.className
        )}
      >
        <HandleLoadingState
          loading={props.loading}
          loadingPlaceholder={
            <BulkLoader
              length={props.loadingPlaceholderNumber || 6}
              component={ProductsLoader}
            />
          }
        >
          {noProductsAvailable || !props.products?.length ? (
            <InfoMessage
              title={t(errors.noProducts)}
              description={t(errors.noProductsDescription)}
              buttonLink="/shop"
            />
          ) : (
            props.products?.map((product) => {
              return (
                <Product
                  key={product.id}
                  gridView={props.gridView}
                  product={product}
                />
              );
            })
          )}
        </HandleLoadingState>
      </div>
      {props.pageInfo && (
        <LoadMoreButton
          onClick={props.onLoadMore}
          loading={props.loading || props.isLoading}
        />
      )}
    </div>
  );
};
